import React from "react";
import { withRouter } from 'react-router-dom';
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
// import RBCarousel from "react-bootstrap-carousel";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./style.css";
import Button from 'react-bootstrap/Button';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { presentation_Creation_API, myHeaders_Autorized } from 'Api/Api';
import axios from 'axios';
import AudioTimer from './AudioTimer';
import Form from "react-bootstrap/Form";
import { org_friendly_url, user_Status_Ver } from 'Api/Api';
// import sanitize from 'sanitize-filename';
import { supported_languages } from 'utils/supported_languages';
import { local_routes } from 'utils/Routes';
// import { NavLink } from 'react-router-dom';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import AudioRecorder from './AudioRecorder/AudioRecorder';

import { isIOS } from "react-device-detect";
//const isIOS = true;

import UserContext from 'store/UserContext';

const usingMediaRecorder = typeof window.MediaRecorder !== 'undefined';
//const usingMediaRecorder = false;

class QuickCreatePresentation extends React.PureComponent {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      audio_upload_progress_message: '',
      wrapup_time: 0,
      wrapup_time_changed: false,
      slide_indicator: '',
      showRecordControls: true,
      duration: 0, // recorded audio duration - gotten from AudioTimer
      autoplay: false,
      clickArea: null,
      audioSrc: null, // Audio Analyzer source

      modified_slide_image_urls: [],

      audioOutput: null, // actual recorded data

      audioFileName: null, // audio filename for display purposes
      audioOutputValidate: false,
      audioDelayValidate: false,
      local_file_url: null, // from createObjectURL
      delayTime: 0,
      audioRecordstatus: null, // pass to AudioRecorder
      audioChanged: false,
      audio_delay_changed: false,
      language_selection_changed: false,
      languageSelections: supported_languages,

      languageSelection: "US English (en-US)", // default
      
    };
    this.max_audio_size_bytes = 40000000; // 40MB
    
    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }

    console.log("Presentation constructor props",props);
    if (props.audio_delay) {
      this.state.delayTime = Math.floor(props.audio_delay / 1000);
    }
    if (props.wrapup_time_ms) {
      this.state.wrapup_time = Math.floor(props.wrapup_time_ms / 1000);
    }
    
    if (props.language_abbreviation) {
      for (let language_obj of this.state.languageSelections) {
        if (language_obj.type === props.language_abbreviation) {
          this.state.languageSelection = language_obj['language'];
          break;
        }
      }
    }

    if (props.silent_flag) {
      this.state.audioChanged = true;
      this.state.audioOutput = props.pkAudio;
    }
    
    if (props.pkAudio) {
      let tmp_array = props.pkAudio.split('/');
      this.state.audioFileName = tmp_array[tmp_array.length-1];
    }
    
    if (props.audioType === 'upload' && props.audio_delay) {
      this.state.slide_indicator = 'Cover Slide / Introduction';
    } else if (props.audioType === 'upload') {
      this.state.slide_indicator = 'Slide 1';
    }

    this.audioTimer_handler = this.audioTimer_handler.bind(this);
    
    this.rb_carousel_ref = React.createRef();
    
    this.recorded_audio_ref = React.createRef(); // to interact with uploaded audio
    
    this.max_recording_duration = (this.props.slide_count * this.props.slide_length); // seconds

    // for carousel display    
    let modified_slide_image_urls = [];
    if (this.props.SlideImageArr) {

      let slide_dimensions = '640x360'

      for (let slide_obj of this.props.SlideImageArr) {


        let image_mod_string = "padblack_"+slide_dimensions;
        let array = slide_obj['source'].split("/");
        if (this.props.pad_color) {
          image_mod_string = "pad"+this.props.pad_color+"_"+slide_dimensions;
        }
        modified_slide_image_urls.push(`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${image_mod_string}/${array[5]}`);
      }
      
      if (typeof this.props.slide_cover_index !== undefined && this.props.audioType === 'upload') {
        // add cover image to beginning of slide array
        modified_slide_image_urls.unshift(modified_slide_image_urls[this.props.slide_cover_index]);
      }

      this.state.modified_slide_image_urls = modified_slide_image_urls;
    }
    console.log("Presentation constructor modified_slide_image_urls",modified_slide_image_urls);

    this.auto_play_interval = undefined;
    
    this.previous_seek_pos = 0; // to prevent infinite onSeeking loop
    
  }
  
  audioTimer_handler (duration) {
    console.log("audioTimer_handler",duration, this.props.slide_length);
    this.setState({ duration });
    // move slides here
    let tmp_slide_number = Math.floor(duration / this.props.slide_length);
    if (tmp_slide_number > (this.props.slide_count - 1)) {
      // if they are at the end
      tmp_slide_number = (this.props.slide_count - 1);
      this.controlAudio('inactive');
    }
    //console.log("audioTimer_handler",duration,tmp_slide_number);
    if (this.rb_carousel_ref.current) {
      this.rb_carousel_ref.current.goToSlide(tmp_slide_number);
      /*
      if (duration >= this.max_recording_duration) {
        // stop the recording!
        this.controlAudio('inactive');
      }
      */
      // check if over max duration!
    } else {
      // navigated away maybe - do nothing
    }
    
  }
  
  onKeyPress(event) {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
     if (/\+|-/.test(keyValue)) {
       event.preventDefault();
     }
  }
   
  handleLanguageChange = (e) => {
    this.setState({ languageSelection: e.target.value, language_selection_changed: true });
    
    if (this.props.quickCreateCallback) {
      let language_abbreviation = "en-US"; // default if something went horribly wrong
      for (let language_obj of this.state.languageSelections) {
        if (language_obj['language'] === this.state.languageSelection) {
          language_abbreviation = language_obj.type;
        }
      }
      this.props.quickCreateCallback({ language_abbreviation });
    }
  }

  handleWrapupTimeChange = (e) => {
    console.log("handleWrapupTimeChange",this.recorded_audio_ref.current.paused);

    let tmp_slide_indicator = '';
    if (this.state.delayTime) {
      tmp_slide_indicator = 'Cover Slide / Introduction';
      this.rb_carousel_ref.current.goToSlide(0);
    } else {
      tmp_slide_indicator = 'Slide 1';
      this.rb_carousel_ref.current.goToSlide(1);
    }

    this.setState({
      wrapup_time: e.target.value,
      wrapup_time_changed: true,
      //autoplay:false,
      slide_indicator: tmp_slide_indicator
    });


    this.recorded_audio_ref.current.currentTime = 0;

  }
  
  handleAudioDelayChange = (e) => {
    console.log("handleAudioDelayChange",e.target.value,this.recorded_audio_ref.current.paused);

    let tmp_new_delay_time = e.target.value;
    if (e.target.value === "") {
      tmp_new_delay_time = 0;
    }

    let tmp_slide_indicator = '';
    if (parseInt(tmp_new_delay_time) > 0) {
      tmp_slide_indicator = 'Cover Slide / Introduction';
      this.rb_carousel_ref.current.goToSlide(0);
    } else {
      tmp_slide_indicator = 'Slide 1';
      this.rb_carousel_ref.current.goToSlide(1);
    }

    this.setState({
      delayTime: e.target.value,
      audio_delay_changed: true,
      slide_indicator: tmp_slide_indicator
    });

    this.recorded_audio_ref.current.currentTime = 0;

  }
  
  componentWillUnmount() {
    clearInterval(this.auto_play_interval);
  }

  componentDidMount() {
    // Edit PK Audio upload
    if (this.props.pkAudio !== undefined && this.props.audioType === 'upload') {
      let audio= this.props.pkAudio;
      var self=this;

      var xhr = new XMLHttpRequest();
      xhr.open("GET", audio, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = function () {
        var arrayBufferView = new Uint8Array(this.response);
        var blob = new window.Blob([arrayBufferView], { type: 'audio/mpeg' });
        var urlCreator = window.URL || window.webkitURL;
          self.arrBfr( urlCreator.createObjectURL(blob),blob )
      };
      
      xhr.send();
    }
    if (!this.state.delayTime && this.props.audioType === 'upload') {
      this.rb_carousel_ref.current.goToSlide(1);
    }
  }
  
  arrBfr=(data,blob)=>{
    this.setState({
      local_file_url: data,
      audioOutput: blob,
      audioOutputValidate: false 
    });
  }

  /*
  finishQuickCreate = async () => {
    let language_abbreviation = "en-US"; // default if something went horribly wrong
    for (let language_obj of this.state.languageSelections) {
      if (language_obj['language'] === this.state.languageSelection) {
        language_abbreviation = language_obj.type;
      }
    }
    
    if (this.props.quickCreateCallback) {
      this.props.quickCreateCallback({
        audioSrc: this.state.audioSrc,
        language_abbreviation
      })
    }
  }
  */

  // API Call for Recording and uploading Audio
  AudioPushMet = async () => {
    console.log("AudioPushMet");
    
    let tmp_delay_time = this.state.delayTime;
    if (!tmp_delay_time) {
      // if empty string
      tmp_delay_time = 0;
    }
    let delayTime_ms = parseInt(tmp_delay_time) * 1000;

    if (tmp_delay_time > 300) {
      this.setState({ audioDelayValidate: true });
      return;
    }

    let wrapup_time_ms = 0;
    if (this.state.wrapup_time) {
      wrapup_time_ms = this.state.wrapup_time * 1000;
    }
    
    if (this.state.wrapup_time > 300) {
      this.setState({ audioDelayValidate: true });
      return;
    }

    // make sure we have audio...tricky because if there is already audio (edit) and it didn't change, we won't have audioOutput
    if (!this.state.local_file_url) {
      this.setState({ audioOutputValidate: true });
      return;
    }

    // get language abbreviation value for database
    let language_abbreviation = "en-US"; // default if something went horribly wrong
    for (let language_obj of this.state.languageSelections) {
      if (language_obj['language'] === this.state.languageSelection) {
        language_abbreviation = language_obj.type;
      }
    }

    let presentationEntityId = this.props.PKCreationPresentationId;
    let NextMet = this.props;

    if (presentationEntityId === null) {
      console.error("ERROR - no presentation uuid");
      return;
    }

    this.setState({
      saving: true
    });

    if (this.state.audioChanged || this.props.audioType === 'record') {
      console.log("Uploading Audio");
      let audioPromise;
      let audioPromise_response;
      let self = this;
      if (this.state.audioOutput) {
        audioPromise = new Promise(resolve => {
          let reader = new FileReader();
          reader.readAsArrayBuffer(this.state.audioOutput);
          reader.onload = () => resolve(reader.result);
        });
        audioPromise_response = await audioPromise;
      }
      
      if (!audioPromise_response) {
        console.error("Audio File Data Read Failed!")
        return;
      }

      let extension = self.state.audioFileName.split('.').pop();

      let asset_type = "audio"; // for uploaded files
      let tmp_audio_filename = 'audio_'+(new Date().getTime())+'.'+extension;
      
      if (this.props.audioType === 'record') {
        asset_type = "raw_audio";
        tmp_audio_filename = 'raw_'+tmp_audio_filename;
      }
      
      let params = {
          asset_type,
          filename: tmp_audio_filename
      }
      
      let response = await axios.post(`${presentation_Creation_API}/${presentationEntityId}/getUploadSignedUrl`, {}, { params, ...myHeaders_Autorized });
      if (response === null) {
        console.error("ERROR - audio getUploadSignedUrl FAILED");
        return;
      }
      
      let dataRes = response.data;
      let audio_length_bytes = audioPromise_response.byteLength;
      console.log("About to upload bytes",audio_length_bytes);
      if (audio_length_bytes > this.max_audio_size_bytes) {
          this.setState({
            //modalLoader: false,
            saving: false,
            audio_problem_message: 'Audio filesize is too large ('+audio_length_bytes+' bytes) - please limit slide filesize to < '+this.max_audio_size_bytes+' bytes'
          });
          return;
      }      
      
      const config = {
        headers: {
          "Content-Type": dataRes.content_type,
          "Content-Disposition": "attachment"
        },
        onUploadProgress: (progressEvent) => {
          let upload_percent = Math.floor(progressEvent.loaded / audio_length_bytes * 100);
          //console.log("AUDIO UPLOADING PROGRESS",progressEvent.loaded,upload_percent);
          this.setState({
            audio_upload_progress_message: 'Presentation Audio: Uploaded '+upload_percent+'%'
          });
        }
      };
      // audio upload
      await axios.put(dataRes.upload_url, audioPromise_response, config);
    }
    
    // if user is not verified, they can't publish/create videos and transcriptions
    if (user_Status_Ver !== "1") {
      console.log("User is not verified - cannot publish (create video/transcript)");
      NextMet.next();
      return;
    }
    
    // do we need to create new video?
    console.log("Trigger Decision",this.props.slidesChanged,this.state.audioChanged,this.state.language_selection_changed,this.state.audio_delay_changed,this.props.audioType);
    let make_video_bool = false;
    let make_transcript_bool = false;

    if (this.props.slidesChanged) {
      make_video_bool = true;
    }
    if (this.state.audioChanged || this.props.audioType === 'record') {
      make_video_bool = true;
      make_transcript_bool = true;
    }
    if (this.state.language_selection_changed) {
      make_transcript_bool = true;
    }
    if (this.state.audio_delay_changed) {
      make_video_bool = true;
    }

    let patch_obj = {
      trigger_create_presentation_video: make_video_bool,
      language_abbreviation: language_abbreviation,
      audio_delay: delayTime_ms,
      video_assembly_method: "presentation_audio",
      wrapup_time_ms
    };
    if (this.props.audioType === 'record') {
      // wipeout old audio url
      patch_obj.audio_url = "";
    } else {
      patch_obj.trigger_create_presentation_transcript = make_transcript_bool;
    }

    //console.log("Final presentation patch for trigger and audio options",JSON.stringify(PatchImageInPresentation,null,2));
    console.log("Final presentation patch for trigger and audio options");

    await axios.patch(`${presentation_Creation_API}/${presentationEntityId}`, patch_obj, myHeaders_Autorized);
    
    // sleep for 2s so My PKs displays processing properly
    if (make_video_bool || make_transcript_bool) {
      setTimeout(() => {
        this.props.next();
      }, 1000);
    } else {
      this.props.next();
    }
    return;
  }

  // Audio recording 
  controlAudio(audioRecordstatus) {
    if (this.props.checkUserEligible) {
      if (!this.props.checkUserEligible()) {
        return;
      }
    }
    
    if (audioRecordstatus === 'recording' && this.state.audioRecordstatus === 'inactive') {
      // restarting
      if (this.rb_carousel_ref.current) {
        this.rb_carousel_ref.current.goToSlide(0);
      }
      this.setState({duration:0,audioSrc:null,slide_indicator:''});
      
      if (this.props.quickCreateCallback) {
        this.props.quickCreateCallback({ audioOutput: null });
      }
    }
    this.setState({
      showRecordControls: false,
      audioRecordstatus,
      audioOutputValidate: false,
    });

  }

  // audio upload autoplay start method
  seekRecording = () => {
    //console.log("seekRecording 1",this.recorded_audio_ref.current.currentTime,this.previous_seek_pos,this.state.delayTime);
    if (Math.abs(this.recorded_audio_ref.current.currentTime - this.previous_seek_pos) < 1) {
      //console.log("seekRecording bailout",this.recorded_audio_ref.current.currentTime,this.previous_seek_pos);
      // did not move much - bail w/o changing anything
      return;
    } else {
      
    }
    clearInterval(this.auto_play_interval);
    
    let tmp_delay_time = this.state.delayTime;
    if (!tmp_delay_time) {
      tmp_delay_time = 0;
    }
    tmp_delay_time = parseInt(tmp_delay_time);
    
    let adjusted_time = this.recorded_audio_ref.current.currentTime;
    let start_at_zero = false;
    
    if (this.state.delayTime) {
      adjusted_time = adjusted_time - tmp_delay_time;
      if (adjusted_time <= 0) {
        adjusted_time = 0;
        start_at_zero = true;
      }
    }

    let tmp_slide_number = Math.floor(adjusted_time / this.props.slide_count);
    
    // can't go over slide 20; meaning index 19 here
    if (tmp_slide_number >= this.props.slide_count) {
      tmp_slide_number = (this.props.slide_count - 1);
    }
    
    //console.log("HMM",start_at_zero,tmp_slide_number,tmp_delay_time);
    if (this.rb_carousel_ref.current) {
      // seek to nearest slide break!
      if (start_at_zero && this.props.audioType === 'upload') {
        // we have audio delay > 0, so show cover slide
        this.recorded_audio_ref.current.currentTime = 0;
        this.setState({slide_indicator:'Cover Slide / Introduction'});
        console.log("Going to cover slide");
        this.rb_carousel_ref.current.goToSlide(0);
      } else {
        
        this.recorded_audio_ref.current.currentTime = (tmp_slide_number * this.props.slide_count) + tmp_delay_time;
        this.setState({slide_indicator:'Slide '+(tmp_slide_number+1)});
        if (this.props.audioType === 'upload') {
          console.log("Going to slide "+(tmp_slide_number+1));
          this.rb_carousel_ref.current.goToSlide(tmp_slide_number+1);
        } else {
          this.rb_carousel_ref.current.goToSlide(tmp_slide_number);
        }
      }
      this.previous_seek_pos = this.recorded_audio_ref.current.currentTime;
      
      //console.log("seekRecording 2",this.recorded_audio_ref.current.currentTime,this.state.delayTime,adjusted_time,tmp_slide_number);
    } else {
      // navigated away maybe - do nothing
    }
  }

  onAutoPlaySlideChange = (slide_number) => {
    if (!this.recorded_audio_ref.current) {
      // do nothing - we are recording
      return;
    }
    console.log("onAutoPlaySlideChange",slide_number,this.recorded_audio_ref.current.paused);
    if (!this.recorded_audio_ref.current.paused) {
      if (this.props.audioType === 'upload') {
        // handle cover slide
        if (slide_number === 0) {
          this.setState({slide_indicator: 'Cover Slide / Introduction'});
        } else {
          this.setState({slide_indicator: 'Slide '+slide_number});
        }
        
      } else if (this.state.audioRecordstatus === 'inactive') {
        // no cover slide
        this.setState({slide_indicator: 'Slide '+(slide_number+1)});
      }
    }
  }

  // audio upload autoplay start method
  startRecording = (inc_delay_time) => {
    let tmp_delay_time;
    if (inc_delay_time && !isNaN(parseInt(inc_delay_time))) {
      tmp_delay_time = parseInt(inc_delay_time);
    } else {
      if (this.state.delayTime) {
        tmp_delay_time = parseInt(this.state.delayTime);
      } else {
        tmp_delay_time = 0;
      }
    }
    console.log("startRecording",tmp_delay_time,this.recorded_audio_ref.current.currentTime);
    clearInterval(this.auto_play_interval);
    // don't start slideshow until we get past intro
    if (tmp_delay_time && (this.recorded_audio_ref.current.currentTime < tmp_delay_time)) {
      let interval_ms = (tmp_delay_time - this.recorded_audio_ref.current.currentTime) * 1000;
      console.log("Intro - delaying autoplay",interval_ms);
      this.auto_play_interval = setInterval(() => {
        clearInterval(this.auto_play_interval);
        
        this.setState({
          autoplay: true,
        });
        this.setState({slide_indicator:'Slide 1'});
        this.rb_carousel_ref.current.goToSlide(1);
      }, interval_ms);
    } else if (this.recorded_audio_ref.current.currentTime < 0.01) {
      this.setState({slide_indicator:'Slide 1'});
      if (this.rb_carousel_ref.current) {
        if (this.props.audioType === 'upload') {
          this.rb_carousel_ref.current.goToSlide(1);
        } else {
          this.rb_carousel_ref.current.goToSlide(0);
        }
      }
      console.log("Autoplay started at Slide 1 with no audioDelay");
      this.setState({
        autoplay: true,
      })
    } else {
      console.log("Autoplay started");
      this.setState({
        autoplay: true,
      })
    }
  }
  
  // audio upload autoplay pause method
  pauseRecording = () => {
    // jump to beginning of the current slide
    this.seekRecording();
    clearInterval(this.auto_play_interval);
    this.setState({
      autoplay: false,
    })
  }
  
  // Audio file upload method
  onChangeAudioFile(event) {
    if (event.target.files[0] !== null && event.target.files[0] !== undefined) {
      let local_file_url = window.URL.createObjectURL(event.target.files[0]);
      
      let tmp_slide_indicator = '';
      if (this.state.delayTime) {
        tmp_slide_indicator = 'Cover Slide / Introduction';
        this.rb_carousel_ref.current.goToSlide(0);
      } else {
        tmp_slide_indicator = 'Slide 1';
        this.rb_carousel_ref.current.goToSlide(1);
      }
      
      this.setState({
        audioOutput: event.target.files[0],
        audioFileName: event.target.files[0].name,
        local_file_url: local_file_url,
        audioChanged: true,
        audioOutputValidate:false,
        autoplay:false,
        slide_indicator: tmp_slide_indicator
      })
    }
  }

  onClickPre = () => {
    this.props.prev();
  }

  handleCancel = async () => {
    let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
    this.props.history.push(next_page);
  }

  componentDidUpdate() {
    // to handle getting duration to show when done recording
    if (this.recorded_audio_ref && this.recorded_audio_ref.current) {
      console.log("componentDidUpdate with audio ref"); 
      // JBB - this takes some hacking to get the duration
      if (isNaN(this.recorded_audio_ref.current.duration) || this.recorded_audio_ref.current.duration === Infinity) {
        this.recorded_audio_ref.current.onloadedmetadata = (async () => {
          this.recorded_audio_ref.current.currentTime = 1000000;
          this.recorded_audio_ref.current.ontimeupdate = (async () => {
            this.recorded_audio_ref.current.ontimeupdate = null;
            console.log("Retrieved audio duration",this.recorded_audio_ref.current.duration)
            this.recorded_audio_ref.current.currentTime = 0;
          });
        });
      }
    }
  }

  render() {
    const { audioSrc, audioRecordstatus, showRecordControls, audioOutputValidate, audioDelayValidate, languageSelections } = this.state;
    
    let carousel_holder_class = 'carousel-holder-black';
    if (this.props.pad_color && this.props.pad_color === 'white') {
      carousel_holder_class = 'carousel-holder-white';
    }
    const audioProps = {
      recording_status: audioRecordstatus,
      startCallback: () => {
        console.log("startCallback");
        this.setState({
          clickArea: 'recording',
          showRecordControls: true
        })
      },
      pauseCallback: () => {
        console.log("pauseCallback");
        this.setState({
          clickArea: 'paused',
          showRecordControls: true
        })
      },
      unpauseCallback: () => {
        console.log("unpauseCallback");
        this.setState({
          clickArea: 'recording',
          showRecordControls: true
        })
      },
      // to stop timer
      stopCallback: () => {
        console.log("stopCallback");
        this.setState({
          clickArea: 'inactive',
          slide_indicator: ''
        });
      },
      // to actually show the audio and controls
      finishCallback: (audioOutput,local_file_url,mimeType) => {
        console.log("finishCallback",local_file_url,mimeType);
        let extension = "webm";
        if (mimeType.startsWith('audio/wav')) {
          extension = "wav";
        } else if (mimeType.startsWith('audio/mp4')) {
          extension = "mp4";
        }
        
        if (this.rb_carousel_ref.current) {
          this.rb_carousel_ref.current.goToSlide(0);
        }
        this.setState({
          audioSrc: local_file_url,
          local_file_url: local_file_url,
          clickArea: 'inactive',
          audioOutput,
          audioFileName: `${this.props.PKCreationPresentationName}.${extension}`,
          showRecordControls: true
        });
        
        if (this.props.quickCreateCallback) {
          this.props.quickCreateCallback({ audioOutput });
        }
      },
      failureCallback: () => {
        this.props.backToSelectAudio();
      }
    }
    
    let upload_button_text = "Upload Audio File";
    if (this.state.audioFileName) {
      upload_button_text = "Upload New Audio File";
    }

    return (
      <div className="container-fluid form-card" id="slides-carousel">
        {/* Validations */}
        {/*
        {
          audioDelayValidate === true
            ?
            <p className="PKAudioError flex-center">Audio delay / wrapup time should be less than 300 seconds</p>
            :
            null
        }

        {
          audioOutputValidate === true
            ?
            <p className="PKAudioError flex-center">Please provide valid audio</p>
            :
            null
        }
        {this.state.saving === true &&
          <p className="PKAudioSuccess flex-center">Uploading Audio</p>
        }
        
        { this.state.audio_upload_progress_message &&
          <p className="PKAudioSuccess flex-center">{this.state.audio_upload_progress_message}</p>
        }
        { this.state.audio_problem_message &&
          <p className="PKAudioError flex-center">{this.state.audio_problem_message}</p>
        }

        <Row>
          <Col xs={6} style={{ fontSize:"smaller", cursor: "pointer" }} onClick={() => this.props.backToSelectAudio()}>
            <i className="fa fa-angle-double-left"></i> Go Back to Select Audio
          </Col>
          <Col xs={6} className="flex justify-content-end">
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding:"0px", paddingTop: "20px" }} className="">
            <RBCarousel
              className={carousel_holder_class}
              animation={true}
              leftIcon={false}
              wrap={false}
              autoplay={this.state.autoplay} // used for uploaded audio
              slideshowSpeed={this.props.slide_length * 1000}
              controls={false}
              onSelect={this.onAutoPlaySlideChange}
              version={4}
              ref={this.rb_carousel_ref}
              pauseOnVisibility={false}
            >
              {this.state.modified_slide_image_urls.map((item,i) =>
                  <div key={i} className="carousel-img">
                    <img style={{ border:"1px solid black", width: "100%", height: "100%" }} src={item} alt="img"/>
                  </div>
                )
              }
            </RBCarousel>
          </Col>
        </Row>
        */}
        <div>
          <Form>
            {/* Language Selection dropdown */}
            { !this.props.silent_flag &&
            <Form.Group controlId="lanTranscript" >
              {/*<div className="form-dropdownlist lang-dropdownlist" style={{ width: "300px" }}>*/}
                <Form.Control
                  as="select"
                  required
                  disabled={!this.context.user_info.entity_uuid || this.context.user_info.status_code !== 1}
                  onChange={this.handleLanguageChange}
                  value={this.state.languageSelection}
                  //style={{ paddingRight: "50px" }}
                >
                  {
                    languageSelections.map((item) =>
                      <option key={item.type}>{item['language']}</option>
                    )
                  }
                </Form.Control>
              {/*</div>*/}
            </Form.Group>
            }

            {/* Audio delay in upload option */}
            {
              (this.props.audioType === "upload" && !this.props.silent_flag) &&
                <React.Fragment>
                  <Form.Group controlId="audioDelay">
                    <div className="form-dropdownlist">
                      <Form.Label>Intro Length (seconds until first slide)</Form.Label>
                      <Form.Control
                        required
                        type="number"
                        min="0"
                        max="300"
                        placeholder="In seconds - 300 maximum"
                        onChange={this.handleAudioDelayChange}
                        onKeyPress={this.onKeyPress.bind(this)}
                        value={this.state.delayTime}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group controlId="wrapup_time">
                    <div className="form-dropdownlist">
                      <Form.Label>Wrapup Time (seconds after last slide)</Form.Label>
                      <Form.Control
                        required
                        type="number"
                        min="0"
                        max="300"
                        placeholder="In seconds - 300 maximum"
                        onChange={this.handleWrapupTimeChange}
                        onKeyPress={this.onKeyPress.bind(this)}
                        value={this.state.wrapup_time}
                      />
                    </div>
                  </Form.Group>
                </React.Fragment>
            }
          </Form>
        </div>
        {
          this.props.audioType === "record"
            ?
            // Recording Audio section
            <React.Fragment>
            <Row>
              <Col lg={12}>
                <AudioTimer
                  audioTimer_handler={this.audioTimer_handler}
                  clickArea={this.state.clickArea}
                  seconds_per_slide={this.props.slide_length}
                  required_slide_count={this.props.slide_count}
                />
                
                <div className="audio-recording">
                  
                  <div className="recording btnControls">

                    {/*<AudioAnalyser {...audioProps}>*/}
                      <div className="btn-box recording-button">
                        {showRecordControls ?
                          <div>
                            {this.state.clickArea === null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("recording")}>Start Recording</Button>}
                            {this.state.clickArea === "inactive" && audioSrc !== null &&
                              <Button className="btn-success"
                                variant="secondary"
                                onClick={() => this.controlAudio("recording")}>Restart Recording</Button>}
                            {this.state.clickArea === "recording" &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("paused")}>Pause Recording</Button>}
                            {this.state.clickArea === "paused" &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("recording")}>Unpause Recording</Button>}
                            {(this.state.clickArea === "paused" || this.state.clickArea === "recording") && this.state.duration >= this.props.slide_length &&
                              <Button className="btn-danger"
                                variant="secondary"
                                disabled={this.state.saving}
                                onClick={() => this.controlAudio("inactive")}>Finish Recording</Button>}
                          </div>
                        :
                          <ActivityIndicator theme="button-Status-Loader" />
                        }
                        {(this.state.clickArea === "inactive" && audioSrc === null) ?
                          <span><em>Audio Processing - Please be patient</em></span>
                        : null
                        }
                      </div>

                  </div>
                  <div className="center upload-audiofile">
                      <AudioRecorder
                        {...audioProps}
                        audioRef={this.recorded_audio_ref}
                        audioSeekCallback={() => this.seekRecording}
                        audioPauseCallback={() => this.pauseRecording}
                        audioStartCallback={() => this.startRecording}
                        slide_indicator={this.state.slide_indicator}
                      />
                  </div>
                </div>
              </Col>
            </Row>
            { (isIOS && !usingMediaRecorder) &&
            <Row style={{ marginTop: "20px" }}>
              <Col xs={12} className="flex justify-content-center">
                <span style={{ fontSize: "smaller"}}>iOS audio recording will work best in Safari, and by enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; 2. Enable MediaRecorder</span>
              </Col>
            </Row>
            }
            </React.Fragment>
            : 
            // Upload audio section
            (this.props.audioType === "upload") ?
              <div>
                { !this.props.silent_flag &&
                <div style = {{ marginBottom: "5px" }} className=" upload-audio flex-center">
                  <Button className="btn btn-danger btn-global">
                    {upload_button_text}
                    <form className="uploader" encType="multipart/form-data">
                      <input
                        type="file"
                        accept="audio/*"
                        onChange={e => this.onChangeAudioFile(e)}
                      />
                    </form>
                  </Button>
                  <br/>
                </div>
                }
                
                <div style={{ display: this.state.local_file_url || this.props.receivedProps  ? "block" : "none" }}
                  className="center upload-audiofile">
                  {this.state.audioFileName ?
                    <div>
                    <span>{this.state.slide_indicator}<br/></span>
                    <span>Current audio filename: {this.state.audioFileName}<br/></span>
                    </div>
                    :
                    null
                  }

                  <audio
                    style = {{ width: "100%" }}
                    ref={this.recorded_audio_ref}
                    controls="controls" 
                    src={this.state.local_file_url} 
                    onSeeked={this.seekRecording}
                    onPause={this.pauseRecording}
                    onPlay={this.startRecording}
                  />

                </div>
              </div>
              : null
        }
         
          {/* Previous & Publish buttons */}
          <div className="form-group btn-position">
              {/*
              <button
                className="btn btn-draft"
                onClick={this.onClickPre}
                disabled={this.state.saving}
              >
                Previous
              </button>
              <button
                className="btn btn-draft"
                onClick={() => this.handleCancel()}
                disabled={this.state.saving}
              >
                Cancel
              </button>
              <button
                className="btn btn-publish"
                onClick={this.AudioPushMet}
                disabled={this.state.saving}
              >
                Finish (Save + Create Video)
              </button>
              */}
              
              {/*
              <Button
                variant="pkprimary"
                onClick={this.finishQuickCreate}
                disabled={this.state.saving}
              >
                Finish (Save + Create Video)
              </Button>
              */}
          </div>
        </div>
    );
  }
}

export default withRouter(QuickCreatePresentation);
